export default __webpack_public_path__ + "img/bbEdAbtO.dffa5402.svg";